import {
    Component,
    Input,
    OnInit,
    AfterViewInit,
    ViewChild,
} from "@angular/core";
import {
    trigger,
    state,
    style,
    transition,
    animate,
} from "@angular/animations";
import { Location } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import { MenuItem, ScrollPanel } from "primeng/primeng";
import { AppComponent } from "./app.component";
import { TOKE_NAME, PATH_PORTAL, USER_MENUS } from "./_shared/var.constant";
import { MenusService, ApiResponse } from "./_services";
import { LoginService } from "./_handler/login.service";

@Component({
    selector: "app-menu",
    templateUrl: "./app.menu.component.html",
    styleUrls: ["./topbar.css"],
})
export class AppMenuComponent implements OnInit, AfterViewInit {
    @Input() reset: boolean;

    @Input() model: any[];
    baseUrl: any;
    listaUrl: any[];
    banderaMenu = 0;
    estadomenu = 1;
    estadomenuspam = 1;
    mobile: any;
    email: string;
    menus = [];
    submenus = [];
    respMenu: any;
    menucache = [];
    menuuser: any;

    @ViewChild("layoutMenuScroller") layoutMenuScrollerViewChild: ScrollPanel;

    constructor(
        public app: AppComponent,
        private menuService: MenusService,
        public loginService: LoginService,
        public router: Router
    ) { }
    move() {
        if (this.estadomenu === 2) {
            this.estadomenu = 1;
            setTimeout(() => {
                this.estadomenuspam = 1;
            }, 300);
        } else {
            if (this.app.staticMenuMobileActive) return;
            this.estadomenu = 2;
            setTimeout(() => {
                this.estadomenuspam = 2;
            }, 30);
        }
    }

    ngOnInit() {
        this.mobile =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent
            );
        this.changeTheme("yellow", "light");
        this.app.lightMenu = false;

        if (this.loginService.estaLogueado()) {
            const mk = JSON.parse(sessionStorage.getItem(USER_MENUS));
            this.model = mk;
        }

        setTimeout(() => {
            this.resizeTop();
        }, 300);
    }

    resizeTop() {
        if (this.mobile) {
            const elm = <HTMLElement>document.getElementById("layout-sidebar");
            if (elm != null) {
                elm.style.paddingTop = "0px";
                // elm.style.top = '90px';
            }
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.layoutMenuScrollerViewChild.moveBar();
        }, 100);
    }

    changeTheme(theme: string, scheme: string) {
        const layoutLink: HTMLLinkElement = <HTMLLinkElement>(
            document.getElementById("layout-css")
        );
        layoutLink.href = "assets/layout/css/layout-" + theme + ".css";

        const themeLink: HTMLLinkElement = <HTMLLinkElement>(
            document.getElementById("theme-css")
        );
        themeLink.href = "assets/theme/theme-" + scheme + ".css";
    }

    onMenuClick(event) {
        if (!this.app.isHorizontal()) {
            setTimeout(() => {
                this.layoutMenuScrollerViewChild.moveBar();
            }, 450);
        }

        this.app.onMenuClick(event);
    }
}

@Component({
    /* tslint:disable:component-selector */
    selector: "[app-submenu]",
    /* tslint:enable:component-selector */
    template: `
        <ng-template
            ngFor
            let-child
            let-i="index"
            [ngForOf]="root ? item : item.items"
        >
            <li
                [ngClass]="{ 'active-menuitem': isActive(i) }"
                [class]="child.badgeStyleClass"
                *ngIf="child.visible === false ? false : true"
            >
                <a
                    [href]="child.url || '#'"
                    (click)="itemClick($event, child, i)"
                    (mouseenter)="onMouseEnter(i)"
                    *ngIf="!child.routerLink"
                    [ngClass]="child.styleClass"
                    [attr.tabindex]="!visible ? '-1' : null"
                    [attr.target]="child.target"
                >
                    <i [ngClass]="child.icon"></i>
                    <span
                        [ngClass]="{
                            'layout-menuitem-active': true,
                            'layout-menuitem-inactive':
                                appMenu.estadomenuspam == 2
                        }"
                        >{{ child.label }}</span
                    >
                    <i
                        ng-style="font-size: 20px"
                        class="fa fa-fw fa-angle-down layout-menuitem-toggler"
                        *ngIf="child.items && appMenu.estadomenu == 1"
                    ></i>
                    <span
                        class="menuitem-badge"
                        *ngIf="child.badge && appMenu.estadomenu == 1"
                        >{{ child.badge }}</span
                    >
                </a>
                <a
                    (click)="itemClick($event, child, i)"
                    (mouseenter)="onMouseEnter(i)"
                    *ngIf="child.routerLink"
                    routerLinkActive="active-menuitem-routerlink"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [attr.tabindex]="!visible ? '-1' : null"
                    [attr.target]="child.target"
                >
                    <i [ngClass]="child.icon"></i>
                    <i
                        class="fa fa-fw fa-angle-right layout-submenuitem-toggler"
                    ></i>
                    <span
                        [ngClass]="{
                            'layout-menuitem-active': true,
                            'layout-menuitem-inactive':
                                appMenu.estadomenuspam == 2
                        }"
                        >{{ child.label }}</span
                    >
                    <i
                        class="fa fa-fw fa-angle-down layout-menuitem-toggler"
                        *ngIf="child.items && appMenu.estadomenu == 1"
                    ></i>
                    <span
                        class="menuitem-badge"
                        *ngIf="child.badge && appMenu.estadomenu == 1"
                        >{{ child.badge }}</span
                    >
                </a>
                <div class="layout-menu-tooltip">
                    <div class="layout-menu-tooltip-arrow"></div>
                    <div class="layout-menu-tooltip-text">
                        {{ child.label }}
                    </div>
                </div>
                <ul
                    app-submenu
                    [ngClass]="{ 'layout-sub-menu': appMenu.estadomenu == 2 }"
                    [item]="child"
                    *ngIf="child.items"
                    [visible]="isActive(i)"
                    [reset]="reset"
                    [parentActive]="isActive(i)"
                    [@children]="
                        (app.isSlim() || app.isHorizontal()) && root
                            ? isActive(i)
                                ? 'visible'
                                : 'hidden'
                            : isActive(i)
                            ? 'visibleAnimated'
                            : 'hiddenAnimated'
                    "
                ></ul>
            </li>
        </ng-template>
        <ng-template> </ng-template>
    `,
    animations: [
        trigger("children", [
            state(
                "hiddenAnimated",
                style({
                    height: "0px",
                })
            ),
            state(
                "visibleAnimated",
                style({
                    height: "*",
                })
            ),
            state(
                "visible",
                style({
                    height: "*",
                    "z-index": 100,
                })
            ),
            state(
                "hidden",
                style({
                    height: "0px",
                    "z-index": "*",
                })
            ),
            transition(
                "visibleAnimated => hiddenAnimated",
                animate("400ms cubic-bezier(0.86, 0, 0.07, 1)")
            ),
            transition(
                "hiddenAnimated => visibleAnimated",
                animate("400ms cubic-bezier(0.86, 0, 0.07, 1)")
            ),
        ]),
    ],
})
export class AppSubMenuComponent {
    @Input() item: MenuItem;

    @Input() root: boolean;

    @Input() visible: boolean;

    _parentActive: boolean;

    _reset: boolean;

    activeIndex: number;

    constructor(public app: AppComponent, public appMenu: AppMenuComponent) { }

    itemClick(event: Event, item: MenuItem, index: number) {
    if (this.root) {
        this.app.menuHoverActive = !this.app.menuHoverActive;
    }

    if (item.disabled) {
        event.preventDefault();
        return true;
    }

    if (item.routerLink) {
        this.activeIndex = index;
        const currentUrl = this.appMenu.router.url;

        let targetUrl: string;
        if (Array.isArray(item.routerLink)) {
            targetUrl = item.routerLink[0];
        } else {
            targetUrl = item.routerLink;
        }

        if (!/^https?:\/\//.test(targetUrl) && !targetUrl.startsWith('/')) {
            targetUrl = '/' + targetUrl;
        }

        const esUrlAbsoluta = /^https?:\/\//.test(targetUrl);

        if (esUrlAbsoluta) {
            window.open(targetUrl, item.target || '_blank');
            event.preventDefault();
            return;
        } else {
            if (currentUrl === targetUrl) {
                this.appMenu.router
                    .navigateByUrl('/', { skipLocationChange: true })
                    .then(() => {
                        if (Array.isArray(item.routerLink)) {
                            this.appMenu.router.navigate(item.routerLink);
                        } else {
                            this.appMenu.router.navigate([item.routerLink]);
                        }
                    });
                event.preventDefault();
                return;
            } else {
                if (Array.isArray(item.routerLink)) {
                    this.appMenu.router.navigate(item.routerLink);
                } else {
                    this.appMenu.router.navigate([item.routerLink]);
                }
            }
        }
    } else {
        this.activeIndex = this.activeIndex === index ? null : index;
    }

    if (item.command) {
        item.command({ originalEvent: event, item: item });
    }

    if (item.items || (!item.url && !item.routerLink)) {
        setTimeout(() => {
            this.appMenu.layoutMenuScrollerViewChild.moveBar();
        }, 450);
        event.preventDefault();
    }

    if (!item.items) {
        if (this.app.isHorizontal() || this.app.isSlim()) {
            this.app.resetMenu = true;
        } else {
            this.app.resetMenu = false;
        }
        this.app.overlayMenuActive = false;
        this.app.staticMenuMobileActive = false;
        this.app.menuHoverActive = !this.app.menuHoverActive;
    }
}



    onMouseEnter(index: number) {
        if (
            this.root &&
            this.app.menuHoverActive &&
            (this.app.isHorizontal() || this.app.isSlim()) &&
            !this.app.isMobile() &&
            !this.app.isTablet()
        ) {
            this.activeIndex = index;
        }
    }

    isActive(index: number): boolean {
        return this.activeIndex === index;
    }

    @Input() get reset(): boolean {
        return this._reset;
    }

    set reset(val: boolean) {
        this._reset = val;

        if (this._reset && (this.app.isHorizontal() || this.app.isSlim())) {
            this.activeIndex = null;
        }
    }

    @Input() get parentActive(): boolean {
        return this._parentActive;
    }

    set parentActive(val: boolean) {
        this._parentActive = val;

        if (!this._parentActive) {
            this.activeIndex = null;
        }
    }
}
